import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import { PromoText } from 'components/no-auth/common/PromoText/PromoText';

import PromoComplexPopup from '../../popup/PromoComplexPopup';
import { PromoButton } from '../PromoButton/PromoButton';
import { PromoRow } from '../PromoRow/PromoRow';

const BtnContainer = styled.div`
    margin-top: 64px;
    text-align: right;
`;

const DownloadAppPopup = (props) => {
    return (
        <PromoComplexPopup withoutButton popupRef={props.popupRef}>
            {props.img && (
                <PromoRow indent={'adaptive-24-32'}>
                    <img src={props.img?.[0].url} alt={''} />
                </PromoRow>
            )}
            <PromoRow indent={'adaptive-24-32'}>
                <PromoText color="gray80" tag="div" variant="h3">
                    {props.popupTitle}
                </PromoText>
            </PromoRow>
            <PromoText color="gray40" tag="div" variant="subheader">
                {props.popupSubTitle}
            </PromoText>
            {props.btnCaption && (
                <BtnContainer>
                    <PromoButton caption={props.btnCaption} type={'link'} href={props.btnHref} id={'downloadAppBtn'} />
                </BtnContainer>
            )}
        </PromoComplexPopup>
    );
};

DownloadAppPopup.propTypes = {
    popupRef: PropTypes.shape({ current: PropTypes.object }),
    popupTitle: PropTypes.string,
    popupSubTitle: PropTypes.string,
    btnCaption: PropTypes.string,
    btnHref: PropTypes.string,
    img: PropTypes.array,
};

const mapStateToProps = (state) => {
    return {
        popupTitle: state.extra?.strapiApi?.download_app_popup?.title,
        popupSubTitle: state.extra?.strapiApi?.download_app_popup?.subtitle,
        btnCaption: state.extra?.strapiApi?.download_app_popup?.btn_cta?.title,
        btnHref: state.extra?.strapiApi?.download_app_popup?.btn_cta?.url,
        img: state.extra?.strapiApi?.download_app_popup?.img,
    };
};
export default connect(mapStateToProps, null)(DownloadAppPopup);
